









































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import ActionTable from '@/components/question-editor/editor-extensions/nodes/node-table/Action.vue';
import ActionTextAlign from '@/components/question-editor/editor-extensions/extensions/extension-text-align/Action.vue';
import { Editor } from '@tiptap/core';

@Component({
  components: {
    ActionTable,
    ActionTextAlign,
  },
})
export default class EditorOption extends Vue {
  @Prop()
  editor!: Editor;

  addImage() {
    const url = window.prompt('URL');

    if (url) {
      this.editor
        .chain()
        .focus()
        .setImage({ src: url })
        .run();
    }
  }
}
